import { ApolloCache } from '@apollo/client';
import { PostId, ReactionType } from '../model/post.types';

type CachedReaction = {
  __typename: 'Reaction';
  type: ReactionType;
  count: number;
  isToggled: boolean;
};

export const modifyPostCommentCount = (
  cache: ApolloCache<unknown>,
  postId: PostId,
  delta: number,
): void => {
  const id = cache.identify({ __typename: 'Post', id: postId });
  if (id === undefined) return;

  cache.modify({
    id,
    fields: {
      reactions: (existing: CachedReaction[] = []) => {
        const hasComment = existing.some(
          (reaction) => reaction.type === ReactionType.Comment,
        );
        if (!hasComment) {
          return delta > 0
            ? [
                ...existing,
                {
                  __typename: 'Reaction' as const,
                  type: ReactionType.Comment,
                  count: delta,
                  isToggled: false,
                },
              ]
            : existing;
        }
        return existing
          .map((reaction) =>
            reaction.type === ReactionType.Comment
              ? { ...reaction, count: reaction.count + delta }
              : reaction,
          )
          .filter(
            (reaction) =>
              reaction.type !== ReactionType.Comment || reaction.count > 0,
          );
      },
    },
  });
};
